<template>
  <div class="row q-col-gutter-md">
    <div
      class="col-12 col-sm-6 col-md-3"
      v-for="grupo in gruposDistribuidos"
      :key="grupo.nome"
    >
      <div>
        <div class="row q-pb-xs">
          <span class="midia-app-label-sm">Dispositivos {{ grupo.nome }}</span>
        </div>

        <div class="row q-pb-xs">
          <span class="midia-app-label-sm">Início {{ grupo.dataInicio }}</span>
        </div>

        <div class="row q-pb-xs">
          <span class="midia-app-label-sm text-grey-6">{{ grupo.pcs.length }} dispositivos</span>
        </div>

        <div class="row items-center q-pb-x">
          <c-q-btn
            padding="none"
            propBtnLabel=""
            :propBtnFunction="() => onDownloadDevicesGreenBtnClick(grupo)"
            :propBtnTransparent="true"
            :propBtnSize="EnumButtonSizes.SMALL"
            :propBorderless="true"
          >
            <template v-slot:default>
              <q-icon size="32px">
                <img src="@/assets/icons/icon_HiOutlineDocumentDownload.svg" alt="download" />
              </q-icon>
            </template>
          </c-q-btn>

          <span class="midia-app-label-lg q-ml-sm ellipsis">
            {{ DEFAULT_PC_GROUP_EXPORT_FILENAME.replaceAll('{0}', grupo.nome) }}
          </span>
        </div>

        <div class="row q-py-xs">
          <c-q-btn
            propBtnLabel="Download"
            :propBtnFunction="() => onDownloadDevicesBtnClick(grupo)"
            :propBtnTransparent="true"
            :propBtnSize="EnumButtonSizes.SMALL"
          />
        </div>
      </div>
    </div>

    <div v-if="loading" class="q-pa-sm">
      <span class="midia-app-label-sm text-grey-6">Carregando dispositivos...</span>
    </div>

    <div v-else-if="gruposDistribuidos.length === 0" class="q-pa-sm">
      <span class="midia-app-label-sm text-grey-6">Nenhum dispositivo encontrado.</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { EnumButtonSizes } from '@/enums/enums'
import { computed, onMounted, ref } from 'vue'
import { DEFAULT_PC_GROUP_EXPORT_FILENAME } from '@/static/constantsInstitutional'
import moment from 'moment'
import { useInstitutionalStore } from '@/stores/institutionalStore'
import { watch } from 'vue'

const props = defineProps<{
  pcsPorGrupo?: Record<string, any[]>
  pcs?: any[] // allPcs
}>()


const institutionalStore = useInstitutionalStore()

const CHUNK_SIZE = 100
const todosPcs = ref<any[]>([])
const loading = ref(false)

/* =====================
 * BUSCA TODAS AS PÁGINAS
 * ===================== */


/*watch(
  () => institutionalStore.institutionalDetail?.id,
  async (id) => {
    if (!id) return

    loading.value = true
    try {
      await institutionalStore.fetchPcsDistribuicao(id, 0)

      const dist = institutionalStore.distribuicao

      const totalPages = dist?.totalPcPages ?? 1
      const acumulado = [...(dist?.pcsTela || [])]

      for (let page = 1; page < totalPages; page++) {
        await institutionalStore.fetchPcsDistribuicao(id, page)

        const distPage = institutionalStore.distribuicao
        acumulado.push(...(distPage?.pcsTela || []))
      }

      todosPcs.value = acumulado

    } catch (error) {
      console.error('Erro ao buscar distribuição:', error)
    } finally {
      loading.value = false
    }
  },
  { immediate: true }
)*/
/* =====================
 * DISTRIBUIÇÃO D0~D3
 * ===================== */
interface GrupoDistribuicao {
  nome: string
  dataInicio: string
  pcs: any[]
}

/*const gruposDistribuidos = computed((): GrupoDistribuicao[] => {
  if (!todosPcs.value.length) return []

  const dtIni = institutionalStore.institutionalDetail?.dtIniVigencia
  if (!dtIni) return []

  const nomeGrupos = ['D0', 'D1', 'D2', 'D3']
  const total = todosPcs.value.length

  // ✅ ≤ 100 → grupo único D0
  if (total <= CHUNK_SIZE) {
    return [{
      nome: 'D0',
      dataInicio: formatarData(dtIni, 0),
      pcs: todosPcs.value
    }]
  }*/

  // ✅ > 100 → distribui em grupos de 100
  /*const grupos: GrupoDistribuicao[] = []

  for (let i = 0; i < nomeGrupos.length; i++) {
    const inicio = i * CHUNK_SIZE
    const isUltimo = i === nomeGrupos.length - 1

    // ✅ último grupo absorve o restante
    const slice = isUltimo
      ? todosPcs.value.slice(inicio)
      : todosPcs.value.slice(inicio, inicio + CHUNK_SIZE)

    if (!slice.length) break

    grupos.push({
      nome: nomeGrupos[i],
      dataInicio: formatarData(dtIni, i),
      pcs: slice
    })

    if (!isUltimo && inicio + CHUNK_SIZE >= total) break
  }

  return grupos
})*/

const gruposDistribuidos = computed(() => {
  if (!props.pcsPorGrupo) return []

  const dtIni = institutionalStore.institutionalDetail?.dtIniVigencia ?? ''

  return Object.entries(props.pcsPorGrupo)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([grupo, pcs], index) => ({
      nome: grupo,
      dataInicio: formatarData(dtIni, index),
      pcs
    }))
})



/* =====================
 * DATAS
 * ===================== */
const formatarData = (date: string, diasOffset: number): string => {
  if (!date) return '-'

  return moment(date, ['DD/MM/YYYY', 'YYYY-MM-DD'])
    .add(diasOffset, 'days')
    .format('DD/MM/YYYY')
}

/* =====================
 * DOWNLOAD
 * ✅ usa campos corretos do TelaDistribuicaoPcDTO
 * ===================== */
const exportCsv = (pcs: any[], filename: string) => {
  if (!pcs?.length) return

  const header = ['Codigo PC', 'Nome', 'Status', 'Motivo']


const rows = pcs.map((pc: any) => {
  const dist = props.pcs?.find(
    (p: any) => String(p.pc) === String(pc.codpontocaptura)
  )

  return [
    pc.codpontocaptura ?? '-',

    // ✅ agora pega o nome correto da tabela
    dist?.nome ?? pc.nompontocaptura ?? '-',

    dist?.status ?? '-',
    dist?.motivo ?? '-'
  ]
})


  const csvContent = [
    header.join(';'),
    ...rows.map(row => row.join(';'))
  ].join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${filename}.csv`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  URL.revokeObjectURL(url)
}


const onDownloadDevicesBtnClick = (grupo: GrupoDistribuicao) => {
  const baseName =
    DEFAULT_PC_GROUP_EXPORT_FILENAME?.replaceAll('{0}', grupo.nome) ||
    `pcs_grupo_${grupo.nome}`

  exportCsv(grupo.pcs, baseName)
}

const onDownloadDevicesGreenBtnClick = (grupo: GrupoDistribuicao) => {
  onDownloadDevicesBtnClick(grupo)
}
</script>

<style scoped></style>
